(function () {
  'use strict';

  // LOOL PD Handler — prima PD vrednost iz kalkulatora i upisuje je u LOOL dropdown.
  // Link intercepcija je uklonjena — LOOL link u product description direktno vodi na app.

  function getLOOLPdSelect() {
    return [...document.querySelectorAll('.lool-select')]
      .filter(function (s) { return s.options && s.options.length > 0; })
      .pop() || null;
  }

  function setLOOLPdValue(pd) {
    var sel = getLOOLPdSelect();
    if (!sel) return false;

    // Round to nearest 0.5 (LOOL range 40–80.5, step 0.5)
    var rounded = String(Math.round(Number(pd) * 2) / 2);

    // Native setter — bypasses React controlled component event system
    var setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
    setter.call(sel, rounded);
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    sel.dispatchEvent(new Event('input',  { bubbles: true }));
    return true;
  }

  // Receive PD value back from calculator (desktop / Android postMessage path)
  window.addEventListener('message', function (e) {
    if (e.data && e.data.type === 'PD_RESULT' && e.data.value != null) {
      setLOOLPdValue(e.data.value);
    }
  });

})();
